import {
	GET_GOOGLEAUTOSUGGESTIONS,
  GET_GOOGLEMAPPLACEDETAILS,
  GET_GOOGLEMAPDIRECTION,
  GET_GEOCODE,
} from "resources/actionTypes";

export function getAutoComplete(data) {
  return {
    type: GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_REQUESTED,
    payload: data,
  };
}
export function clearAutoComplete() {
  return {
    type: GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_CLEARED,
  };
}
export function getPlaceDetails(getPlaceDetails) {
  const data = getPlaceDetails
  return {
    type: GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_REQUESTED,
    payload: data,
  };
}
export function getDirection(getDirectionDetails) {
  const data = {
    addressData : {
      destination: getDirectionDetails?.destination,
      origin: getDirectionDetails?.origin,
    }
  };

  return {
    type: GET_GOOGLEMAPDIRECTION.GET_GOOGLEMAPDIRECTION_REQUESTED,
    payload: data,
  };
}
export function getGeocode(data) {
  return {
    type: GET_GEOCODE.GET_GEOCODE_REQUESTED,
    payload: data,
  };
}

export function clearPlaceDetails() {
  return {
    type: GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_CLEARED,
  };
}